<script setup lang="ts">
import { usePreviewRectangleStore } from 'shared/map/stores/previewRectangleStore';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { Anchor } from 'shared/map/domain/anchor';
import { Fieldset, Select, InputNumber } from 'primevue';
import UpDownInputNumber from '@/common/components/UpDownInputNumber.vue';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);
const previewRectangleStore = usePreviewRectangleStore();

const {
  length,
  lengthChanged,
  width,
  widthChanged,
  geofenceBottom,
  geofenceBottomChanged,
  geofenceLeft,
  geofenceLeftChanged,
  geofenceRight,
  geofenceRightChanged,
  geofenceTop,
  geofenceTopChanged,
  anchor,
  anchorChanged,
  heading,
  headingChanged,
  longitude,
  longitudeChanged,
  latitude,
  latitudeChanged
} = storeToRefs(previewRectangleStore);

const anchorOptions = ref<AnchorOptions[]>([
  Anchor.Center,

  Anchor.BottomCenter,
  Anchor.BottomLeft,
  Anchor.BottomRight,

  Anchor.TopCenter,
  Anchor.TopLeft,
  Anchor.TopRight
].map(a => {
  return {
    name: translations.value.enums.anchor(a),
    value: a
  };
}));

interface AnchorOptions {
  name: string;
  value: Anchor;
}

</script>

<template>
  <div class="rectangle-form">

    <div class="field" :class="{ changed: longitudeChanged }">
      <label>{{ translations.generic.longitude }}</label>
      <InputNumber v-model:model-value="longitude" :maxFractionDigits="7">
      </InputNumber>
    </div>

    <div class="field" :class="{ changed: latitudeChanged }">
      <label>{{ translations.generic.latitude }}</label>
      <InputNumber v-model:model-value="latitude" :maxFractionDigits="7">
      </InputNumber>
    </div>

    <div class="field" :class="{ changed: lengthChanged }">
      <label>{{ translations.generic.length }}</label>
      <UpDownInputNumber v-model:model-value="length">
      </UpDownInputNumber>
    </div>

    <div class="field" :class="{ changed: widthChanged }">
      <label>{{ translations.generic.width }}</label>
      <UpDownInputNumber v-model:model-value="width">
      </UpDownInputNumber>
    </div>

    <div class="field" :class="{ changed: headingChanged }">
      <label>{{ translations.generic.direction }}</label>
      <UpDownInputNumber v-model:model-value="heading">
      </UpDownInputNumber>
    </div>

    <div class="field" :class="{ changed: anchorChanged }">
      <label>{{ translations.generic.anchor }}</label>
      <Select v-model:model-value="anchor" :options="anchorOptions"
        option-label="name" option-value="value">
      </Select>
    </div>

    <Fieldset class="geofence-fields" :legend="translations.shapes.geofenceFieldSet">

      <div class="field" :class="{ changed: geofenceTopChanged }">
        <label>{{ translations.generic.top }}</label>
        <UpDownInputNumber v-model:model-value="geofenceTop">
        </UpDownInputNumber>
      </div>

      <div class="field" :class="{ changed: geofenceBottomChanged }">
        <label>{{ translations.generic.bottom }}</label>
        <UpDownInputNumber v-model:model-value="geofenceBottom">
        </UpDownInputNumber>
      </div>

      <div class="field" :class="{ changed: geofenceLeftChanged }">
        <label>{{ translations.generic.left }}</label>
        <UpDownInputNumber v-model:model-value="geofenceLeft">
        </UpDownInputNumber>
      </div>

      <div class="field" :class="{ changed: geofenceRightChanged }">
        <label>{{ translations.generic.right }}</label>
        <UpDownInputNumber v-model:model-value="geofenceRight">
        </UpDownInputNumber>
      </div>

    </Fieldset>
  </div>
</template>

<style scoped>
.rectangle-form {
  display: grid;
  gap: .5rem;
  grid-template-columns: repeat(2, 1fr);
}

.geofence-fields{
  grid-column: 1/3;
}

.geofence-fields :deep(.p-fieldset-content) {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: .5rem;
}
</style>
